
export const isEditingInProgress = (name, bool) => { 

	return { 
		type: 'IS_EDITING_IN_PROGRESS', 
		name: name,
		value: bool
	}
}





// WEBPACK FOOTER //
// ./src/redux/actions/AppAction.js